<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="brand_page.list_title" />

    <BrandList
      :brands="filteredBrands"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteBrand"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateBrandModal
      :open="showModal"
      :is-edit="!!selectedBrand"
      :form="form"
      :errors="errors"
      :loading="loading"
      :preview-url="previewUrl"
      @close="closeModal"
      @save="saveBrand"
      @generate-code="generateBrandCode"
      @update-field="updateField"
      @file-change="handleFileUpload"
      @remove-image="removeImage"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateBrandModal from "../../components/Settings/Brand/CreateBrandModal.vue";
import BrandList from "../../components/Settings/Brand/BrandList.vue";
import { useBrand } from "../../composables/useBrand";

const {
  searchQuery,
  filteredBrands,
  showModal,
  selectedBrand,
  form,
  errors,
  loading,
  previewUrl,
  paginationConfig,
  fetchBrands,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  handleFileUpload,
  removeImage,
  generateBrandCode,
  saveBrand,
  deleteBrand,
} = useBrand();

onMounted(fetchBrands);
</script>
